import { IInitialCatalogTarifsState } from 'interfaces/catalogTarifs.interface';
import * as CatalogTarifsType from './catalogTarifs.types';

export default function catalogTarifsReducer(
  state: IInitialCatalogTarifsState,
  action: any
) {
  const { type, payload } = action;

  switch (type) {
    case CatalogTarifsType.SET_CATALOG_TARIFS: {
      const getCatalogTarifs: IInitialCatalogTarifsState = {
        ...state,
        catalogTarifs: payload,
      };
      return getCatalogTarifs;
    }

    case CatalogTarifsType.RESET_CATALOG_TARIFS: {
      const resetCatalogTarifs: IInitialCatalogTarifsState = {
        ...state,
        catalogTarifs: [],
        tarifSelected: null,
      };
      return resetCatalogTarifs;
    }

    case CatalogTarifsType.SET_IS_LOADING_CATALOG_TARIFS: {
      const setIsLoadingCatalogTarifs: IInitialCatalogTarifsState = {
        ...state,
        isLoadingCatalogTarifs: payload,
      };
      return setIsLoadingCatalogTarifs;
    }

    case CatalogTarifsType.SELECT_TARIF: {
      const selectTarif: IInitialCatalogTarifsState = {
        ...state,
        tarifSelected: payload,
      };
      return selectTarif;
    }

    case CatalogTarifsType.SET_IS_LOADING_CREATE_TARIF: {
      const setIsLoadingCreateTarif: IInitialCatalogTarifsState = {
        ...state,
        isLoadingCreateTarif: payload,
      };
      return setIsLoadingCreateTarif;
    }

    case CatalogTarifsType.SET_IS_LOADING_UPDATE_TARIF: {
      const setIsLoadingUpdateTarif: IInitialCatalogTarifsState = {
        ...state,
        isLoadingUpdateTarif: payload,
      };
      return setIsLoadingUpdateTarif;
    }

    case CatalogTarifsType.DELETE_TARIF: {
      const deleteTarif: IInitialCatalogTarifsState = {
        ...state,
        catalogTarifs: state.catalogTarifs.filter((tarif) => tarif.id !== payload),
      };
      return deleteTarif;
    }

    case CatalogTarifsType.IS_LOADING_DELETE_TARIF: {
      const isLoadingDeleteTarif: IInitialCatalogTarifsState = {
        ...state,
        isLoadingDeleteTarif: {
          tarifId: payload.tarifId,
          isLoading: payload.isLoading,
        },
      };
      return isLoadingDeleteTarif;
    }

    case CatalogTarifsType.IS_LOADING_DOWNLOAD_TARIF: {
      const isLoadingDownloadTarif: IInitialCatalogTarifsState = {
        ...state,
        isLoadingDownloadTarif: payload,
      };
      return isLoadingDownloadTarif;
    }

    default:
      return state;
  }
}
